import type { QueryClient } from '@tanstack/react-query'

let connectivityQueryClient: QueryClient | null = null

export function setConnectivityQueryClient(client: QueryClient): void {
  connectivityQueryClient = client
}

export function getConnectivityQueryClient(): QueryClient | null {
  return connectivityQueryClient
}

/** Test-only reset */
export function resetConnectivityQueryClientForTests(): void {
  connectivityQueryClient = null
}
